module.exports = __webpack_public_path__ + "school/img/practiceSeparatePhilosophyBg.d2415dd1.jpg";